module.exports = __webpack_public_path__ + "d836aae0b9d6118cfe1b2e06efb32a9c.svg";